import gql from 'graphql-tag';

export default gql`
    query GetTmsDuplicates($input: TmsDuplicateCheckInput) {
        getTmsDuplicates(input: $input) {
            duplicateTmsIds
        }
    }
`;
